/* @flow */
import localConfig from './localConfig'
import commonConfig from '../common/config'

export const APP_NAME = require('../../package.json').name

export const APP_VERSION = process.env.appVersion || process.env.HEROKU_SLUG_COMMIT
export const IS_PRODUCTION = process.env.NODE_ENV === 'production'
export const APP_PORT = localConfig.port
export const APP_URL = localConfig.url
export const SSR_URL = localConfig.ssrUrl

const config = {
  appName: APP_NAME,
  appVersion: APP_VERSION,
  appUrl: localConfig.url,
  isProduction: IS_PRODUCTION,
  defaultLocale: 'cs',
  locales: ['cs', 'sk', 'en'],
  initDirs: false,
  sentryUrl: 'https://868dc3f5aeec4b1590f4f39fd4719e6b@sentry.io/134656',
  googleAnalyticsId: 'UA-50457871-3',
  zeeratId: 't8wV9gcL',
  smartlookId: 'bca3fd1f8dc28f513080d7f2006ec4c3b48ced7c',
}

let nconf = {}
const finalConfig = Object.assign(config, commonConfig, localConfig)
if (!process.env.IS_BROWSER) {
  nconf = require('nconf')

  nconf.env('__')
  nconf.defaults(finalConfig)
} else {
  nconf.get = () => finalConfig
}
export default nconf.get()



// WEBPACK FOOTER //
// ./src/server/config.js